<template>
  <div class="Login_background">
      <v-container class="login-wrapper" fluid>
        <v-row>
          <div class="pt-0 center">
            <v-content class="mobile-card-view">
              <v-card class="elevation-0">
                <v-img class="login-logo" src="static/senso-logo-black.png"></v-img>
                <v-card-text class="login-frm" style="margin-top: 10px">
                  <p class="Login">Sign in to Senso Learn</p>
                </v-card-text>

                <v-layout row wrap class="login-layout">
                  <v-flex xs12 sm6 md6 lg6 class="pa-4 flex-column">
                    <v-card-text class="login-frm login-input">
                      <v-alert class="mt-8" v-if="errMsg" :value="alert" v-html="errMsg" color="error"></v-alert>

                      <v-text-field v-model="email" type="text" placeholder="johnsmith@email.com" outlined required
                        class="input" @keyup.enter="login" hide-details="auto"></v-text-field>

                      <v-text-field v-model="password" placeholder="*******" outlined required class="input mt-5"
                        :append-icon="showInput ? 'mdi-eye' : 'mdi-eye-off'" :type="showInput ? 'text' : 'password'"
                        @click:append="toggleInputVisibility" @keyup.enter="login" hide-details="auto"></v-text-field>
                      <v-spacer></v-spacer>
                    </v-card-text>
                    <v-card-text class="mt-5 pt-0 pb-0 forgot_password">
                      <span>
                        By logging into Senso Learn you agree to our
                        <a @click.prevent="
                          toggleCheckboxState(privacyPolicyLink)
                          " href="#">Privacy Policy</a>
                        and
                        <a @click.prevent="
                          toggleCheckboxState(termsConditionsLink)
                          " href="#">Terms and Conditions</a>
                      </span>
                    </v-card-text>
                    <v-card-actions class="login-btn">
                      <v-btn v-if="loading" color="dddd" loading></v-btn>
                      <v-btn v-else color="primary" class="login-button" @click="login">Login</v-btn>
                    </v-card-actions>
                    <v-card-text class="forgot_password">
                      <router-link class="" to="/forgot-password">Forgot Password</router-link>
                    </v-card-text>
                  </v-flex>

                  <v-flex xs12 sm6 md6 lg6 class="pa-4 sso-section">
                    <v-card-text class="login-frm login-input">
                      <v-btn @click="loginWithSSO('Microsoft')" class="sso-btn input" x-large>
                        <div class="icon">
                        <img src="/static/microsoft-logo.svg" alt="#" class="mr-5" />
                        </div>
                        <img src="/static/sso-vertical-seperator.png" alt="#" class="mr-3" />
                        <span class="login-text">Login with Microsoft</span>
                      </v-btn>
                      <v-btn @click="loginWithSSO('Google')" class="sso-btn input google-btn" x-large>
                        <div class="icon">
                        <img src="/static/google-logo.svg" alt="#" class="mr-5" />
                        </div>
                        <img src="/static/sso-vertical-seperator.png" alt="#" class="mr-3" />
                        <span class="login-text">Login with Google</span>
                      </v-btn>
                      <v-btn @click="loginWithSSO('Clever')" class="sso-btn input google-btn" x-large>
                        <div class="icon">
                        <img src="/static/clever-login.svg" alt="#" class="mr-5" />
                        </div>
                        <img src="/static/sso-vertical-seperator.png" alt="#" class="mr-3" />
                        <span class="login-text">Login with Clever</span>
                      </v-btn>
                      <v-btn @click="loginWithSSO('ClassLink')" class="sso-btn input google-btn" x-large>
                        <div class="icon">
                        <img src="/static/classlink-icon-symbol-large.png" alt="#" class="mr-5" />
                        </div>
                        <img src="/static/sso-vertical-seperator.png" alt="#" class="mr-3" />
                        <span class="login-text">Login with ClassLink</span>
                      </v-btn>
                    </v-card-text>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-content>
          </div>
        </v-row>
      </v-container>
  </div>
</template>
<script>


export default {
  name: 'SensoLogin',
  components: {
    
  },
  data: () => ({
    password: '',
    email: '',
    valid: true,
    loading: false,
    messages: {
      email: [],
      password: [],
      error: [],
    },
    privacyPolicyLink: 'https://senso.cloud/gb/privacy-policy/',
    termsConditionsLink: 'https://senso.cloud/gb/terms-service-tos/ ',
    alert: true,
    errMsg: '',
    showInput: false,
  }),
  methods: {
    login: function () {
      this.loading = true;
      this.$store
        .dispatch('login', {
          email: this.email,
          password: this.password,
        })
        .then((resp) => {
            this.getProfile();
        })
        .catch((err) => {
          this.loading = false;
          this.valid = false;
          this.messages = [];
          let errors = err.response.data.errors;
          // this.errMsg = err.response.data.message;
          // if (this.errMsg) {
          //   this.errMsg = errors != null && errors.email && errors.email[0].search("The selected email is invalid.") != 0 ? errMsg : "The email/password combination entered was incorrect. Please check your credentials and try again."
          //   this.errorMessage = this.errMsg;
          // }

          if (err.response.status == 401) {
            this.errMsg =
              '<b> Login failed </b> <p> Please Check your sign in details and try again </p>';
          } else if (err.response.status == 500) {
            this.$snotify.error(err.response.data.message);
          }
          if (errors) {
            for (let field in errors) {
              this.messages[field] = errors[field];
            }
          }
        });
    },
    getProfile() {
      this.$store
        .dispatch('profile')
        .then((resp) => {
          switch (this.$store.getters.level) {
            case 1:
              this.$router.push('/super-admin/companies');
              break;
            case 2:
              this.$router.push('/admin/users');
              break;
            case 4:
              this.$router.push('/partner/users');
              break;
            case 5:
              this.$router.push('/partner/users');
              break;
            case 6:
              this.$router.push('/super-admin/billinglist');
              break;
            case 7:
              this.$router.push('/course-library');
              break;
            default:
              this.$router.push('/courses');
              break;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    toggleCheckboxState(link) {
      window.open(link, '_blank'); // Open the link in a new tab
    },
    toggleInputVisibility() {
      this.showInput = !this.showInput;
    },
    loginWithSSO(provider) {
      let url = this.$globalConfig.SSO_URL + '/' + provider;
      window.open(url, '_self');
    },
  },
};
</script>
<style scoped>
.v-content {
  flex: 0 0 auto !important;
}

.v-application .error {
  background-color: #ffcbcb !important;
  border-color: #ffcbcb !important;
  text-align: center;
  color: #4f0e0e;
}

.v-application p {
  margin: 0;
}

.sso-btn {
  padding-top: 27px !important;
  padding-bottom: 27px !important;
  width: 320px;
  height: 56px;
  display: flex;
  justify-content: flex-start;
  color: #333333;
  font-size: 18px;
  background: transparent !important;
  height: 56px;
  border: 1px solid #c4c4c4 !important;
  text-transform: none;
  letter-spacing: 0;
  margin: 0;
}

.sso-btn .icon {
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-size: 25px;
  margin-right: 15px;
  max-width: 25px;
  min-width: 25px;
}

.sso-btn .icon img {
  width: 100%;
  height: 25px;
}
  
.login-text {
  flex: 1;
  text-align: left;
}

.sso-btn:hover{
  box-shadow: 0 0 0.75rem #a8aeba;
    transition: box-shadow 0.25sease-in-out;
}

@media (max-width: 760px) {
  .Login{
    font-size: 24px;
  }
  .center{
    height: 100%;
  }
  .login-input{
    /* padding: 0 10px !important; */
  }
  .sso-btn{
     width: 100%;
  }
  .forgot_password{
    width: 100%;
  }
  .login-wrapper{
        padding: 32px 0;
  }
}
/* Portrait */
@media only screen 
  and (min-device-width: 768px) 
  and (max-device-width: 1024px) 
  and (orientation: portrait) 
  and (-webkit-min-device-pixel-ratio: 2) {
    /* Your CSS for iPad Mini Portrait */
  .forgot_password{
    width: 100%;
  }
  .elevation-0 {
    padding: 20px;
}
}

/* Portrait */
@media only screen 
  and (min-device-width: 820px) 
  and (max-device-width: 1180px) 
  and (orientation: portrait) 
  and (-webkit-min-device-pixel-ratio: 2) {
    /* Your CSS for iPad Air Portrait */
    .forgot_password{
    width: 100%;
  }
  .elevation-0 {
    padding: 20px;
}
}
@media (max-width: 375px) {
    .forgot_password {
        padding-left: 0px !important;
    }
}
</style>